import {CurrencyEnum} from '../../enums';
import {BaseLocationInfo} from '../locations';
import {Page, SearchRequestParams} from '../common';

export enum EnergyType {
    REGULAR_NETWORK = 'REGULAR_NETWORK',
    SOLAR = 'SOLAR',
    BATTERY_STORAGE = 'BATTERY_STORAGE',
}

export enum Month {
    JANUARY = 'JANUARY',
    FEBRUARY = 'FEBRUARY',
    MARCH = 'MARCH',
    APRIL = 'APRIL',
    MAY = 'MAY',
    JUNE = 'JUNE',
    JULY = 'JULY',
    AUGUST = 'AUGUST',
    SEPTEMBER = 'SEPTEMBER',
    OCTOBER = 'OCTOBER',
    NOVEMBER = 'NOVEMBER',
    DECEMBER = 'DECEMBER',
}

export enum DayOfWeek {
    MONDAY = 'MONDAY',
    TUESDAY = 'TUESDAY',
    WEDNESDAY = 'WEDNESDAY',
    THURSDAY = 'THURSDAY',
    FRIDAY = 'FRIDAY',
    SATURDAY = 'SATURDAY',
    SUNDAY = 'SUNDAY',
}

export enum DayOfWeekShortValue {
    MONDAY = 'Mon',
    TUESDAY = 'Tue',
    WEDNESDAY = 'Wed',
    THURSDAY = 'Thu',
    FRIDAY = 'Fri',
    SATURDAY = 'Sat',
    SUNDAY = 'Sun',
}

export interface PriceItemDTO {
    id: number;
    itemPrice: number;
    energyType: EnergyType;
    month: Month;
    dayOfWeek: DayOfWeek;
    hourOfDay: number; // 0-23
}

export interface PriceDTO {
    id: number;
    createdAt: number;
    defaultPrice: number;
    currency: CurrencyEnum;
    items: PriceItemDTO[];
    location: BaseLocationInfo;
}

export interface BasePriceDTO {
    id: number;
    createdAt: number;
    defaultPrice: number;
    currency: CurrencyEnum;
    location: BaseLocationInfo;
}

export interface BaseLocationPriceInfo {
    id: number;
    createdAt: number;
    defaultPrice: number;
    currency: CurrencyEnum;
}

export enum PriceItemSortField {
    ENERGY_TYPE = 'ENERGY_TYPE',
    MONTH = 'MONTH',
    DAY_OF_WEEK = 'DAY_OF_WEEK',
    HOUR_OF_DAY = 'HOUR_OF_DAY',
    CURRENCY = 'CURRENCY',
}

// Request types
export interface PriceItemInfo {
    itemPrice: number;
    energyType: EnergyType;
    month: Month;
    dayOfWeek: DayOfWeek;
    hourOfDay: number; // 0-23
}

export interface PriceInfo {
    defaultPrice: number;
    currency: CurrencyEnum;
}

export interface CreatePriceRequest {
    businessId: number;
    locationId?: number;
    defaultPrice: number;
    currency: CurrencyEnum;
    items?: PriceItemInfo[];
}

export interface UpdatePriceRequest {
    businessId: number;
    defaultPrice: number;
    currency: CurrencyEnum;
    items?: PriceItemInfo[];
    itemsToDelete?: PriceItemInfo[];
    cleaningItems?: boolean; // Only one procedure — either adding or clearing items — is allowed per request.
}

export interface SearchPriceItemRequest {
    data: SearchPriceItemRequestData;
    params?: SearchRequestParams;
}

export interface SearchPriceItemRequestData {
    businessId?: number;
    priceId?: number;
    locationId?: number;
    currency?: CurrencyEnum;
    energyType?: EnergyType;
    month?: Month;
    dayOfWeek?: DayOfWeek;
    hourOfDay?: number; // 0-23
    sortField?: PriceItemSortField;
    sortAsc?: boolean;
}

export interface PagePriceItemDTO extends Page {
    content: PriceItemDTO[];
}